import Swiper from 'swiper';
import {Navigation,Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import {Fancybox} from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import CIHotspot from '@cloudimage/hotspot';

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

import { initGalleryTabs } from '../../../utils/initGalleryTabs';
// import { initScrollLinkedTrack } from '../../../utils/initWelcomeGalleryScroll';
import { initAttributes } from '../../../utils/initAttributesVertical';
import { initPinnedHorizontalTrack } from '../../../utils/initPinnedHorizontalTrack';

require('../../../sitio');
const PopupManager = require('@/utils/PopupManager');

function drawConnectors() {
    const media = document.querySelector('.highlight__media');
    if (!media) return;

    // solo los puntos de las listas left/right — nunca los de --list--mobile
    const list = document.querySelector('.highlight__list--left');
    if (!list || getComputedStyle(list).display === 'none') {
        document.querySelectorAll('.line-horizontal, .line-angled').forEach(el => el.remove());
        return;
    }

    const mediaRect = media.getBoundingClientRect();
    const points = document.querySelectorAll(
        '.highlight__list--left .highlight-point, .highlight__list--right .highlight-point'
    );

    points.forEach(li => {
        const dot = li.querySelector('.highlight-point__dot');
        const dotRect = dot.getBoundingClientRect();
        const isLeft = li.classList.contains('highlight-point--left');
        const connector = li.dataset.connector; // 'first' | 'last' | 'middle'

        const dotStyle = getComputedStyle(dot);
        const outlineOffset = parseFloat(dotStyle.outlineOffset) || 0;
        const outlineWidth = parseFloat(dotStyle.outlineWidth) || 0;
        const edgeOffset = dotRect.width / 2 + outlineOffset + outlineWidth;

        const startX = isLeft
            ? dotRect.left + dotRect.width / 2 + edgeOffset
            : dotRect.left + dotRect.width / 2 - edgeOffset;
        const startY = dotRect.top + dotRect.height / 2;

        let horizontal = li.querySelector('.line-horizontal');
        if (!horizontal) {
            horizontal = document.createElement('div');
            horizontal.className = 'line-horizontal';
            li.appendChild(horizontal);
        }
        const liRect = li.getBoundingClientRect();
        const imageEdgeX = isLeft ? mediaRect.left : mediaRect.right;

        if (connector === 'middle') {
            const overlap = 20;
            const straightWidth = Math.abs(imageEdgeX - startX) + overlap;
            horizontal.style.left = `${(isLeft ? startX : imageEdgeX - overlap) - liRect.left}px`;
            horizontal.style.top = `${startY - liRect.top}px`;
            horizontal.style.width = `${straightWidth}px`;
            li.querySelector('.line-angled')?.remove();
            return;
        }

        // first/last
        const breakDistance = 80;
        const breakX = isLeft ? startX + breakDistance : startX - breakDistance;
        const isLast = connector === 'last';
        const angle = isLast
            ? (isLeft ? -55 : -125)
            : (isLeft ? 55 : 125);

        const angleRad = angle * Math.PI / 180;
        const overlap = 20;
        const remainingX = Math.abs(imageEdgeX - breakX) + overlap;
        const angledLength = remainingX / Math.abs(Math.cos(angleRad));

        let angled = li.querySelector('.line-angled');
        if (!angled) {
            angled = document.createElement('div');
            angled.className = 'line-angled';
            li.appendChild(angled);
        }

        horizontal.style.left = `${(isLeft ? startX : breakX) - liRect.left}px`;
        horizontal.style.top = `${startY - liRect.top}px`;
        horizontal.style.width = `${breakDistance}px`;

        angled.style.left = `${breakX - liRect.left}px`;
        angled.style.top = `${startY - liRect.top}px`;
        angled.style.width = `${angledLength}px`;
        angled.style.transform = `rotate(${angle}deg)`;
    });
}
let resizeTimeout;
function scheduleRedraw() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(drawConnectors, 50);
}
function initConnectors() {
    const media = document.querySelector('.highlight__media');
    if (!media) return;

    const observer = new ResizeObserver(scheduleRedraw);
    observer.observe(media);

    const img = media.querySelector('.highlight__image');
    if (img) {
        if (img.complete) {
            drawConnectors();
        } else {
            img.addEventListener('load', drawConnectors, { once: true });
        }
    }
}

document.addEventListener('DOMContentLoaded', function ()
{
    Fancybox.bind("[data-fancybox]", {
        Toolbar: {
            display: {
                left: ["infobar"],
                middle: [],
                right: ["close"],
            },
        },
    });

    initGalleryTabs();
    initAttributes();
    initConnectors();

    const swiperWelcomeEl = document.querySelector(".swiper-welcome");
    const welcomeGallery = document.querySelector('[data-js="welcome-gallery"]');
    const isSwiperMode = welcomeGallery?.classList.contains('swiper-welcome');
    if (isSwiperMode) {
        const swiperWelcome = new Swiper(swiperWelcomeEl, {
            loop: true,
            modules: [Autoplay],
            autoplay: {
                delay: 2000,
                pauseOnMouseEnter: true,
            },
            breakpoints: {
                320: { slidesPerView: 1.25, spaceBetween: 10 },
                390: { slidesPerView: 2.25, spaceBetween: 10 },
                640: { slidesPerView: 2.25, spaceBetween: 10 },
                768: { slidesPerView: 2.75, spaceBetween: 10 },
                1024: { slidesPerView: 5.25, spaceBetween: 10 },
                1280: { slidesPerView: 6, spaceBetween: 10 }
            }
        });
    } else if (welcomeGallery) {
        initPinnedHorizontalTrack({
            section: '#welcome.welcome',
            wrapper: '[data-js="welcome-gallery"]',
            track: '[data-js="welcome-gallery-track"]',
            scrub: 1,
            offsetTop: () => document.getElementById('project-navbar')?.offsetHeight ?? 0,
        });
    }

    const isAvailableCIHotspot = document.querySelector(".masterplan__media_content-hotspot");
    if (isAvailableCIHotspot)
    {
        CIHotspot.autoInit();
        let masterplanHotspotInstance = null;
        const el = document.querySelector('.masterplan__hotspots');

        if (!el || typeof CIHotspot === 'undefined') return;

        masterplanHotspotInstance = new CIHotspot(el, {
            src: el.dataset.ciHotspotSrc,
            alt: el.dataset.ciHotspotAlt,
            zoom: true,
            trigger: 'click',
            pulse: false,
            hotspots: JSON.parse(el.dataset.ciHotspotItems || '[]'),
        });

        document.querySelectorAll('.masterplan__point').forEach((point) => {
            const hotspotId = point.dataset.hotspotId;

            if (!hotspotId) return;

            point.addEventListener('click', () => {
                masterplanHotspotInstance.open(hotspotId);
            });
        });

        document.querySelectorAll('.masterplan__point').forEach((point) => {
            const hotspotId = point.dataset.hotspotId;

            if (!hotspotId) return;

            point.addEventListener('mouseenter', () => {
                masterplanHotspotInstance.open(hotspotId);
                point.classList.add('is-active');
            });

            point.addEventListener('mouseleave', () => {
                masterplanHotspotInstance.close(hotspotId);
                point.classList.remove('is-active');
            });

            point.addEventListener('click', () => {
                masterplanHotspotInstance.open(hotspotId);
            });
        });
    }

    const mql = window.matchMedia("(min-width: 1440px)");

    // ============================================
    // MODO CARRUSEL
    // ============================================

    const swiperSurroundingEl = document.querySelector(".surroundings__content--carousel .swiper-surrounding");
    let swiperSurrounding = null;

    if (swiperSurroundingEl) {
        swiperSurrounding = new Swiper(swiperSurroundingEl, {
            loop: true,
            modules: [Navigation],
            watchOverflow: false,
            navigation: {
                nextEl: ".swiper-next-surrounding",
                prevEl: ".swiper-prev-surrounding",
            },
            breakpoints: {
                320: { slidesPerView: 1, spaceBetween: 10 },
                390: { slidesPerView: 1.5, spaceBetween: 10 },
                640: { centeredSlides: true, slidesPerView: 2, spaceBetween: 10 },
                768: { centeredSlides: true, slidesPerView: 2.35, spaceBetween: 10 },
                1024: { centeredSlides: true, slidesPerView: 3, spaceBetween: 10 },
                1280: { centeredSlides: false, slidesPerView: 4, spaceBetween: 10 },
            },
            on: {
                init(swiper) {
                    swiper.slides[swiper.activeIndex]?.classList.add("swiper-slide-active");
                    if (mql.matches) swiper.navigation.disable();
                },
                slideChange(swiper) {
                    swiper.slides.forEach((slide) => slide.classList.remove("swiper-slide-active"));
                    swiper.slides[swiper.activeIndex]?.classList.add("swiper-slide-active");
                },
            },
        });
    }

    // ============================================
    // MODO GRID
    // ============================================

    const gridContainer = document.querySelector(".surroundings__content--grid");
    const nextBtn = document.querySelector(".swiper-next-surrounding");
    const prevBtn = document.querySelector(".swiper-prev-surrounding");

    let gridItems = [];
    let activeIndex = 0;

    if (gridContainer) {
        gridItems = Array.from(gridContainer.querySelectorAll(".surroundings__grid-item"));

        function setActive(index) {
            gridItems.forEach((item) => item.classList.remove("is-active"));
            gridItems[index]?.classList.add("is-active");
            activeIndex = index;
        }

        setActive(0);

        gridItems.forEach((item, index) => {
            item.addEventListener("click", () => setActive(index));
        });
    }

    // ============================================
    // BOTONES COMPARTIDOS — un solo listener, decide según el modo activo
    // ============================================

    nextBtn?.addEventListener("click", () => {
        if (mql.matches) {
            if (!gridItems.length) return;
            activeIndex = (activeIndex + 1) % gridItems.length;
            gridItems.forEach((item) => item.classList.remove("is-active"));
            gridItems[activeIndex]?.classList.add("is-active");
        }
        // si NO es mql.matches, no hacemos nada acá:
        // Swiper ya maneja el click nativamente vía su propio nextEl listener
    });

    prevBtn?.addEventListener("click", () => {
        if (mql.matches) {
            if (!gridItems.length) return;
            activeIndex = (activeIndex - 1 + gridItems.length) % gridItems.length;
            gridItems.forEach((item) => item.classList.remove("is-active"));
            gridItems[activeIndex]?.classList.add("is-active");
        }
    });

    // ============================================
    // Sincronizar navigation de Swiper al cruzar el breakpoint
    // ============================================

    mql.addEventListener("change", (e) => {
        if (!swiperSurrounding) return;
        if (e.matches) {
            swiperSurrounding.navigation.disable();
        } else {
            swiperSurrounding.navigation.enable();
        }
    });

    const swiperModelsEl = document.querySelector(".swiper-models");
    if (swiperModelsEl) {
        const swiperModels = new Swiper(swiperModelsEl, {
            loop: false,
            modules: [Navigation],
            navigation: {
                nextEl: ".swiper-next-models",
                prevEl: ".swiper-prev-models",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                }
            },
        });
    }

    const promo = document.querySelector('#promotion-quotes');

    if (promo) {
        const inner = promo.querySelector('.promotion');
        const btnClose = promo.querySelector('.btn-close');

        let cycleInterval;
        let hideTimeout;

        // Función para mostrar con fadeIn
        function fadeIn(element) {
            promo.style.display = 'block';
            // Pequeño delay para que la transición funcione
            setTimeout(() => {
                element.classList.remove('fade-out');
                element.classList.add('fade-in');
            }, 10);
        }

        function fadeOut(element) {
            element.classList.remove('fade-in');
            element.classList.add('fade-out');

            element.addEventListener('transitionend', function handler() {
                promo.style.display = 'none';
                element.removeEventListener('transitionend', handler);
            }, { once: true });
        }

        function startCycle() {
            fadeIn(inner);

            hideTimeout = setTimeout(() => {
                fadeOut(inner);
            }, 10000);
        }

        startCycle();

        cycleInterval = setInterval(startCycle, 30000);

        if (btnClose) {
            btnClose.addEventListener('click', () => {
                clearTimeout(hideTimeout);
                clearInterval(cycleInterval);
                fadeOut(inner);
            });
        }
    }

    window.popupManager = new PopupManager();

    // ============================================
    // NAVBAR DE SECCIONES (fixed al pasar el hero + active link)
    // ============================================

    const hero = document.getElementById('hero');
    const navbar = document.getElementById('project-navbar');
    const placeholder = document.getElementById('project-navbar-placeholder');

    if (navbar && hero) {
        const navItems = navbar.querySelectorAll('.navbar__item');
        let navbarHeight = navbar.offsetHeight;

        const setFixedState = (isFixed) => {
            if (isFixed) {
                navbar.classList.add('navbar--fixed');
                placeholder.style.height = `${navbarHeight}px`;
                placeholder.classList.remove('hidden');
            } else {
                navbar.classList.remove('navbar--fixed');
                placeholder.classList.add('hidden');
                placeholder.style.height = '0px';
            }
        };

        const heroObserver = new IntersectionObserver(([entry]) => {
            setFixedState(!entry.isIntersecting);
        }, {
            root: null,
            threshold: 0,
            rootMargin: '0px',
        });

        heroObserver.observe(hero);

        const sections = Array.from(navItems)
            .map(item => document.getElementById(item.dataset.section))
            .filter(Boolean);

        const setActiveItem = (sectionId) => {
            navItems.forEach(item => {
                item.classList.toggle('navbar__item--active', item.dataset.section === sectionId);
            });
        };

        const sectionObserver = new IntersectionObserver((entries) => {
            const visible = entries
                .filter(entry => entry.isIntersecting)
                .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

            if (visible.length > 0) {
                setActiveItem(visible[0].target.id);
            }
        }, {
            root: null,
            rootMargin: `-${navbarHeight + 20}px 0px -60% 0px`,
            threshold: [0, 0.25, 0.5, 0.75, 1],
        });

        sections.forEach(section => sectionObserver.observe(section));

        navItems.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const target = document.getElementById(item.dataset.section);
                if (!target) return;

                const offset = navbar.classList.contains('navbar--fixed') ? navbarHeight + 10 : 0;
                const top = target.getBoundingClientRect().top + window.scrollY - offset;

                window.scrollTo({ top, behavior: 'smooth' });
            });
        });

        // Recalcular altura del navbar en resize + avisarle a ScrollTrigger (debounced)
        let navbarResizeTimeout;
        window.addEventListener('resize', () => {
            navbarHeight = navbar.offsetHeight;
            if (navbar.classList.contains('navbar--fixed')) {
                placeholder.style.height = `${navbarHeight}px`;
            }

            clearTimeout(navbarResizeTimeout);
            navbarResizeTimeout = setTimeout(() => ScrollTrigger.refresh(), 100);
        }, { passive: true });
    }


});

window.addEventListener('resize', scheduleRedraw);
